import getURLParams from 'utils/DOM/getURLParams'

const paramsURL = getURLParams()
const parametersName = [
  'type',
  'deductible',
  'coverage',
  'price',
  'coinsurance',
  'moop',
  'sort'
]

function getFiltersFromUrl() {
  const result = []

  for (const key of parametersName) {
    const value = paramsURL[key]
    if (value) {
      result.push(`${key}=${value}`)
    }
  }

  return result.join('&')
}

export default getFiltersFromUrl
